import { render } from "./PropertyTable.vue?vue&type=template&id=b5d95038&scoped=true"
import script from "./PropertyTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyTable.vue?vue&type=script&setup=true&lang=js"

import "./PropertyTable.vue?vue&type=style&index=0&id=b5d95038&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d95038"],['__file',"src/pages/scada/forms/PropertyTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b5d95038"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b5d95038', __exports__)) {
    console.log('reload')
    api.reload('b5d95038', __exports__)
  }
  
  module.hot.accept("./PropertyTable.vue?vue&type=template&id=b5d95038&scoped=true", () => {
    console.log('re-render')
    api.rerender('b5d95038', render)
  })

}


export default __exports__